import { render, staticRenderFns } from "./MappingDialog.vue?vue&type=template&id=364dd9f7&"
import script from "./MappingDialog.vue?vue&type=script&lang=ts&"
export * from "./MappingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports